import { createFileRoute } from '@tanstack/react-router'

import { PrivacySettingsPage } from '@/pages/settings/privacy/PrivacySettingsPage'

export const Route = createFileRoute('/_authenticated/_dashboard/settings/privacy/')({
  component: PrivacySettingsPage,
})
